import { DateTime } from '@grapecity/wijmo';

export const WJ_LICENSE = window.aerith.wijmoLicenseKey;
//'demo.aerith.sigma-sol.jp|dev.aerith.sigma-sol.jp|dev2.aerith.sigma-sol.jp|dev4.aerith.sigma-sol.jp|elixirs|elixirs.elixir.home,934518164254957#B0l9JpnrJvk/IvlrKomLiOiEmTDJCLicTN9QTNyQjNxgTM5QzM9IiOiQWSiwSfiIjdwIDMyIiOiIXZ6JCLlNHbhZmOiI7ckJye0ICbuFkI1pjIEJCLi4TPRZ5RDBjcKJXVX9ER5JHe8B7aDdmZNh7bwFkNxFXZrY6R9J7QL5kYtRDO0xkc4RkVuRjaupUQJV4QQNWZZR5KqF4RKVlc78mWjRUWtlTRypHWrNEem9GZlFXNphzKV94YU3mYthEdjhTdU34MVt6MwJUMMd6Yvlmezhmc4YzVJRncyhWczkmM7FDc54UZSlXRnV7dxRFVGlmSxRFTPRHbqdFdYZjdqZDSvRUb5Z5L74USZhnSDJGZlZHO74GWDJWSwIWQ8J5dFpUMWdTUNhmRvclWBtkZvxmNvlDcaplaxVGTitiergFZONGbiVVSVVza8Mzd62yYudWUKRVUvw6bLNTN5N7NztyRvVVMXZUNlBjbXdDdJl4djpFa0FWNuRWRSVFWMZDVDVXd7VjY5NVY5J4MZJDZ7ZkTuhFbrYXa6cGMoNnMTNXTYRGZnVXaxljR03CMjRGTiojITJCLiUjMFRzM6czMiojIIJCL9UDN4UjNxQjM0IicfJye35XX3JSSwIjUiojIDJCLi86bpNnblRHeFBCI4VWZoNFelxmRg2Wbql6ViojIOJyes4nI5kkTRJiOiMkIsIibvl6cuVGd8VEIgIXZ7VWaWRncvBXZSBybtpWaXJiOi8kI1xSfis4N8gkI0IyQiwiIu3Waz9WZ4hXRgAydvJVa4xWdNBybtpWaXJiOi8kI1xSfiQjR6QkI0IyQiwiIu3Waz9WZ4hXRgACUBx4TgAybtpWaXJiOi8kI1xSfiMzQwIkI0IyQiwiIlJ7bDBybtpWaXJiOi8kI1xSfiUFO7EkI0IyQiwiIu3Waz9WZ4hXRgACdyFGaDxWYpNmbh9WaGBybtpWaXJiOi8kI1tlOiQmcQJCLiUjMwQjMxASMxkDMxIDMyIiOiQncDJCLiUWbvhmLylGepxWZuMncphXasVGLzJXa8lGblxCcq9CbvNXLh56ZpNnLoRXayVWYuQjdlRGLwpmLs36ctEWbnl6cugGdpJXZh9iM6VGZsAnauw6bz5SYtdWaz9Ca4lmclFmL6VGZsAnauw6bz5SYtdWaz9Ca4lmclFmLv5WZkJiOiMXbEJCLiorgjP1gjf0gjfrgjz1gjX0gjr0gj7rgj19gjDrgRfJg';
//"elixirs.elixir.home|demo.aerith.sigma-sol.jp|dev2.aerith.sigma-sol.jp|dev4.aerith.sigma-sol.jp,967339794369145#B0uilDNxkjNzQTO7kzMzcjN9IiOiQWSiwSfdtlOicGbmJCLiIjdxIDMyIiOiIXZ6JCLlNHbhZmOiI7ckJye0ICbuFkI1pjIEJCLi4TP7hzZ88EcrlERhRXVxNWU0tyV78kbYdTZ7hHUzUGUyoGRu9UawpGcTpXWtlmYnZWe5lWSYNGUihVU9NjRO5kViVHSZpmN5ZlRD56U5IGUn3kNaVGWC9EcLRVUTR6YUBDN7gVexIjZqpmYzxEVQdFS82Ce7lTRvUGMKlDOqlXTh5GT4YWTwI7MzN4ZMJ5TphFOJd7VmN5dIp5Y8JGa58WR6ZnZUZEdvklWWNjet3iQXR5Kp3mT7hTQ4N7Y4kVerh6d7wmb9gVNrQ5KuFEcYFkVywUOLV6N5JFNkpUev96dSB7LVpFNiVFc4Q6LBV5KnF5UKFkdUNVWQJka9xkewgGU8hnbQpWTmBzdtlnZrg5RndVeiVUYB5kYoFkdBZzar94ayAzT5QWazoHZvh6TzdEOWdDTNV7VrF7LzRke0RVdldkQr8US5lXTMV7RwRHcaVXblZ7RK96ViojITJCLikDM7UDO9UzNiojIIJCL6IDNzQjM9YzM0IicfJye&Qf35VfikEMyIlI0IyQiwiIu3Waz9WZ4hXRgACdlVGaThXZsZEIv5mapdlI0IiTisHL3JSNJ9UUiojIDJCLi86bpNnblRHeFBCIyV6dllmV4J7bwVmUg2Wbql6ViojIOJyes4nILdDOIJiOiMkIsIibvl6cuVGd8VEIgc7bSlGdsVXTg2Wbql6ViojIOJyes4nI4YkNEJiOiMkIsIibvl6cuVGd8VEIgAVQM3EIg2Wbql6ViojIOJyes4nIzMEMCJiOiMkIsISZy36Qg2Wbql6ViojIOJyes4nIVhzNBJiOiMkIsIibvl6cuVGd8VEIgQnchh6QsFWaj9WYulmRg2Wbql6ViojIOJyebpjIkJHUiwiIyATO4UDMgQTMyETMyAjMiojI4J7QiwiIwpmLs36ctEWbnl6cugGdpJXZh9CN6VGZsAnauw6bz5SYtdWaz9Ca4lmclFmLyYXZkxCcq9CbvNXLh56ZpNnLoRXayVWYu2WblRGLl56bo9icphXasVmLzJXa8lGblJiOiMXbEJCLiorgjP1gjf0gjfrgjz1gjX0gjr0gj7rgj19gjDrgjfrgj1LpnrJvk/IvlrKomLiOiEmjDtC"
//'demo.aerith.sigma-sol.jp|dev.aerith.sigma-sol.jp|elixirs|elixirs.elixir.home|dev2.aerith.sigma-sol.jp|dev4.aerith.sigma-sol.jp|dev5.aerith.sigma-sol.jp|dev6.aerith.sigma-sol.jp,967339794369145#B05O18lO88qO883K88eO88wK887K88+S09ayL9Pyb9qCq9iojIh94QiwiI5QTM9YzM4kzN9MzM7YTOiojIklkIs4XXbpjInxmZiwiIyYXMyAjMiojIyVmdiwSZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34TUFRUO9t4Q9hzLEtmWronaD3kQoJEOqdjQzV6ckdEenZ4LndWWOZEVsV4bFJ5ZaBFav56RBl5SKdXU9EGTNNnZywUUvI6YN54K0tmdxtmYHZlSLtSez3GZr5Wcy2GTCZ7RSplVthXVPFHMlp7QyIGVTllesF4cUhGNxIXSFxGZ5YTSrpFNm3iaIpFOyomapVDS88kW5Y5VTVlZGNTbQhkZWdlMDljV7pmRjVUZX9WYzkkZjRlV6Nja736MtFXb6RVQoNDU7ZnSthXeGdHeohTT7hne4MjdGBVMuFVSrYEWohFMo3CT4JjSsZDSzVFVKtSWSxGMQFGN6JWMJ3GeUFlNBVjZwITT946atpGN9NFRYlXTWxWQWx6RxUERE36S7Y7RPhlR73GdzQmUn56biZlVPdXcDFkSqFEaVZTeLNlWmFFNE5Ue5kWR7YFWjlHR5ZWe8g5Yu9kI0IyUiwiI8gjRDFzM7EjI0ICSiwCMwUDM4QTM6ITM0IicfJye35XX3JSSwIjUiojIDJCLi86bpNnblRHeFBCI4VWZoNFelxmRg2Wbql6ViojIOJyes4nI5kkTRJiOiMkIsIibvl6cuVGd8VEIgIXZ7VWaWRncvBXZSBybtpWaXJiOi8kI1xSfis4N8gkI0IyQiwiIu3Waz9WZ4hXRgAydvJVa4xWdNBybtpWaXJiOi8kI1xSfiQjR6QkI0IyQiwiIu3Waz9WZ4hXRgACUBx4TgAybtpWaXJiOi8kI1xSfiMzQwIkI0IyQiwiIlJ7bDBybtpWaXJiOi8kI1xSfiUFO7EkI0IyQiwiIu3Waz9WZ4hXRgACdyFGaDxWYpNmbh9WaGBybtpWaXJiOi8kI1tlOiQmcQJCLiMzM5EDOwASNyEDMyIDMyIiOiQncDJCLiAnauw6bz5SYtdWaz9Ca4lmclFmL6YXZkxCcq9CbvNXLh56ZpNnLoRXayVWYuUjdlRGLwpmLs36ctEWbnl6cugGdpJXZh9CN6VGZsAnauw6bz5SYtdWaz9Ca4lmclFmLyYXZkxSZt3GauIXa8lGbl9ycylGepxWZsMncphXasVGLwpmLs36ctEWbnl6cugGdpJXZh9idlRGLwpmLs36ctEWbnl6cugGdpJXZh9ybtVGZiojIz5GRiwiI0K88zO88nO885K64';

export const MenuList = {
  settingMenu: [
    //{
    //  header: '自動更新間隔',
    //  items: [
    //    { id: 10, header: '10秒', checked: true },
    //    { id: 30, header: '30秒', checked: false },
    //    { id: 60, header: '60秒', checked: false },
    //  ],
    //},
  ],

  managementMenu: [
    //{
    //  header: 'ユーザー管理',
    //  type: 'link',
    //  value: { path: '/User' },
    //},
  ],

  functionMenu: [
    {
      header: '患者検索',
      type: 'link',
      value: { path: '~/Patient' },
    },
    {
      header: '訪問指導',
      type: 'link',
      value: { path: '~/VisitSchedule' },
    },
    {
      header: '報告書印刷',
      type: 'link',
      value: { path: '~/Home/ReportBatchPrint' },
    },
    {
      header: 'マニュアル',
      icon: 'IoGridOutline',
      type: 'link',
      value: { path: '~/Documents/operation-manual.pdf' },
    },
  ],

  userMenu: [
    //{
    //  header: 'パスワード変更',
    //  type: 'modal',
    //},
    {
      header: 'ログアウト',
      type: 'link',
      value: { path: '/Login/Logout' },
    },
  ],

  instructionMenu: [
    {
      header: '服薬状況',
      type: 'modal',
    },
    {
      header: '変更確認',
      type: 'modal',
    },
    {
      header: '処方監査',
      type: 'modal',
    },
    {
      header: '印刷',
      type: 'modal',
    },
    {
      header: '薬品情報',
      type: 'modal',
      value: { path: '/DrugInfoSearch' },
    },
    {
      header: '算定歴',
      type: 'modal',
    },
    //{
    //  header: '設定',
    //  items: [
    //    { header: '指導セット' },
    //    { header: '過去指導文データ' },
    //   { header: '聞き取りマスタ' },
    //    { header: 'バイタル・検査値' },
    //    { header: '在宅聞取りマスタ' },
    //  ],
    //},
  ],

  visitMenu: [
    {
      header: '計画',
      type: 'link',
      value: { path: '~/Home/Plan' },
    },
    {
      header: '訪問予定一覧',
      type: 'link',
      value: { path: '~/Home/List' },
    },
    {
      header: '印刷',
      type: 'link',
      value: { path: '~/Home/ExportPDF' },
    },
  ],
};

export const PatientSearch = {
  kansaList: [
    {
      id: 1,
      text: '　済　',
      color: '',
      backgroundColor: 'transparent',
    },
    {
      id: 2,
      text: 'ｴﾗｰ',
      color: 'white',
      backgroundColor: 'red',
    },
    {
      id: 3,
      text: '　確　',
      color: 'white',
      backgroundColor: 'blue',
    },
    {
      id: 4,
      text: '　保　',
      color: '',
      backgroundColor: 'yellow',
    },
  ],

  sidoList: [
    {
      id: 1,
      text: '　済　',
      color: '',
      backgroundColor: 'transparent',
    },
    {
      id: 2,
      text: '　残　',
      color: 'red',
      backgroundColor: '#ffffc8',
    },
  ],

  kaikeiList: [
    {
      id: 0,
      text: '　　　',
      color: '',
      backgroundColor: 'transparent',
    },
    {
      id: 1,
      text: '　済　',
      color: '',
      backgroundColor: 'transparent',
    },
  ],
};

export const Common = {
  gaijiTanniList: [
    {
      charCode: 0xe015,
      convertText: 'l',
    },
    {
      charCode: 0xe016,
      convertText: 'dl',
    },
    {
      charCode: 0xe017,
      convertText: 'c㎡',
    },
    {
      charCode: 0xe018,
      convertText: 'ml',
    },
    {
      charCode: 0xe080,
      convertText: 'μg',
    },
    {
      charCode: 0xe083,
      convertText: 'mci',
    },
    {
      charCode: 0xe084,
      convertText: 'μci',
    },
    {
      charCode: 0xe085,
      convertText: 'MBq',
    },
    {
      charCode: 0xe087,
      convertText: 'pil',
    },
    {
      charCode: 0xe08b,
      convertText: 'cap',
    },
    {
      charCode: 0xe08c,
      convertText: 'Sy',
    },
    {
      charCode: 0xe08d,
      convertText: 'Esy',
    },
    {
      charCode: 0xe08e,
      convertText: 'cr',
    },
  ],
};

export const FUKUYAKU = 2;
export const ATHOME = 35;

export const DateFormatYMDD = 'gee/MM/dd（ddd）';
export const DateFormatYMD = 'gee/MM/dd';
export const DateFormatYM = 'gee/MM';
export const DateFormatY = 'gee';

export const From_YAK = 1;
export const From_MYK = 2;
export const From_MYK_GYK = 3;

/**
 * 分類区分
 * */
export const BunruiKubun = {
  /** [A] 併用薬（既定の分類コード： DIRA） */
  HeiyoYakuhin: 'A',
  /** [B] 患者病名情報（既定の分類コード： DIRB） */
  Byomei: 'B',
  /** [D] 食物アレルギー（既定の分類コード： DIRD） */
  Shoku: 'D',
  /** [E] OTC（既定の分類コード： DIRE） */
  HeiyoOtc: 'E',
  /** [F] 禁忌薬（薬品）（既定の分類コード： DIRF） */
  Kinkiyaku: 'F',
  /** [N] 禁忌薬（系統）（既定の分類コード： DIRN） */
  KinkiyakuKeito: 'N',
  /** [M] サプリなど（既定の分類コード： PH1） */
  HeiyoEtc: 'M',
  /** [G] 妊婦授乳（既定の分類コード： PK1） */
  Ninpu: 'G',
} as const satisfies {
  [key: string]: string;
};

/**
 * DIR 医薬品データベースを参照する分類区分のリスト
 */
export const DirBunruiKubunList = [
  BunruiKubun.HeiyoYakuhin,
  BunruiKubun.Byomei,
  BunruiKubun.Shoku,
  BunruiKubun.HeiyoOtc,
  BunruiKubun.Kinkiyaku,
  BunruiKubun.KinkiyakuKeito,
] as readonly string[];

export const KJ_INFO_BNRICD_CUREKIOU = 'CKO'; //既往歴
/*
export const KJ_INFO_BNRICD_CUREALLERGY = 'CAL'; //アレルギー
export const KJ_INFO_BNRICD_CURESYOKUGYO = 'CSK'; //職業・作業等
export const KJ_INFO_BNRICD_CUREFUKUSAYO = 'CFS'; //副作用歴
export const KJ_INFO_BNRICD_CURESEIKATU = 'CSS'; //生活習慣
export const KJ_INFO_BNRICD_CUREINSYU = 'CIS'; //飲酒
export const KJ_INFO_BNRICD_CUREKITSUEN = 'CKE'; //喫煙
export const KJ_INFO_BNRICD_CUREETCSIKO = 'CES'; //その他嗜好品
export const KJ_INFO_BNRICD_CURESYOJO = 'CSJ'; //症状
//*/

/**
 * ＠HOME ZYJ削除区分定義
 */
export const ZYJ_DELETE_KBN = {
  None: -1,
  OnlyHomon: 0,
  All: 1,
} as const;
export type ZYJ_DELETE_KBN = (typeof ZYJ_DELETE_KBN)[keyof typeof ZYJ_DELETE_KBN];

/**
 * ＠HOME 履歴Tabインデックス定義
 */
export const HOME_HISTORY_TAB_IDX = {
  None: -1,
  Shoho: 0,
  Homon: 1,
  Plan: 2,
  Report: 3,
} as const;
export type HOME_HISTORY_TAB_IDX = (typeof HOME_HISTORY_TAB_IDX)[keyof typeof HOME_HISTORY_TAB_IDX];

/**
 * JCT 業務名定義
 */
export const JCT_GYONM_SIDO = '服薬指導';
export const JCT_GYONM_ZYJ = '訪問予定実績登録';
export const JCT_GYONM_ZRPL = '報告計画書';

/**
 * 表示メッセージ
 */
export const LICENSE_GET_FAILED = 'ライセンス情報の取得に失敗しました。';

export const MSG_SHOHO_SELECT = 'この訪問に対する処方が選択されていません。処方を選択します。';
export const MSG_SHOHO_NO_SELECT = '処方が選択されていません。\n処方入力後に再度登録してください。';

/**
 * パレット患者情報：ステータス
 */
export const KJ_INFO_STATUS_NONE = '　';

/**
 * パレット患者情報(既往歴)：ステータス [0：確　1：現　2：既]
 */
export const KJ_INFO_STATUS_CHECK = '確'; // 0
export const KJ_INFO_STATUS_NOW = '現'; // 1
export const KJ_INFO_STATUS_PAST = '既'; // 2

export const kiouStatusList = [
  {
    value: '4',
    displayName: KJ_INFO_STATUS_NONE,
  },
  {
    value: '0',
    displayName: KJ_INFO_STATUS_CHECK,
  },
  {
    value: '1',
    displayName: KJ_INFO_STATUS_NOW,
  },
  {
    value: '2',
    displayName: KJ_INFO_STATUS_PAST,
  },
];

/**
 * パレット患者情報：ステータス [1：〇　2：×　3：?  4:中止]
 */
export const KJ_INFO_STATUS_OK = '〇'; // 1
export const KJ_INFO_STATUS_NG = '×'; // 2
export const KJ_INFO_STATUS_QUESTION = '?'; // 3
export const KJ_INFO_STATUS_STOP = '中止'; // 4

export const commonStatusList = [
  {
    value: '0',
    displayName: KJ_INFO_STATUS_NONE,
  },
  {
    value: '1',
    displayName: KJ_INFO_STATUS_OK,
  },
  {
    value: '2',
    displayName: KJ_INFO_STATUS_NG,
  },
];

export const heiyoStatusList = [
  {
    value: '0',
    displayName: KJ_INFO_STATUS_NONE,
  },
  {
    value: '1',
    displayName: KJ_INFO_STATUS_OK,
  },
  {
    value: '2',
    displayName: KJ_INFO_STATUS_NG,
  },
  {
    value: '3',
    displayName: KJ_INFO_STATUS_QUESTION,
  },
  {
    value: '4',
    displayName: KJ_INFO_STATUS_STOP,
  },
];

export const KAITEI_202204 = DateTime.newDate(2022, 3, 1);

export const ToastContainerPreset = {
  Common: 'common',
} as const;

export type ToastContainerPreset = (typeof ToastContainerPreset)[keyof typeof ToastContainerPreset];
